import type { Branch } from "@/lib/types/master-data";
import { formatOperationHoursRange } from "@/lib/booking/branch-hours";

export type BookingLocation = {
  value: string;
  label: string;
};

export type BookingLocationDetail = {
  address: string;
  hours: { days: string; time: string }[];
  tel?: string | null;
  email?: string | null;
  icon?: "city";
};

export function branchToValue(branch: Branch): string {
  return String(branch.id);
}

export function branchToLabel(branch: Branch): string {
  return branch.calling_name?.trim() || branch.name;
}

export function branchesToBookingLocations(branches: Branch[]): BookingLocation[] {
  return branches.map((branch) => ({
    value: branchToValue(branch),
    label: branchToLabel(branch),
  }));
}

export function findBranchByValue(
  branches: Branch[],
  value: string,
): Branch | undefined {
  return branches.find((branch) => branchToValue(branch) === value);
}

export function getBranchLocationLabel(
  branches: Branch[],
  value: string,
): string {
  const branch = findBranchByValue(branches, value);
  return branch ? branchToLabel(branch) : "";
}

export function branchToLocationDetail(branch: Branch): BookingLocationDetail {
  return {
    address: branch.address?.trim() || "Contact branch for address",
    tel: branch.tel,
    email: branch.email,
    hours: [
      {
        days: "Mon - Sun",
        time: formatOperationHoursRange(
          branch.operation_start_time,
          branch.operation_end_time,
        ),
      },
    ],
    icon: "city",
  };
}

export function getBranchLocationDetail(
  branches: Branch[],
  value: string,
): BookingLocationDetail | null {
  const branch = findBranchByValue(branches, value);
  return branch ? branchToLocationDetail(branch) : null;
}
